/** */
import { urls } from 'services/_url';
import { apiGet, apiPost } from 'services/_http';

/** */
const base_url = `${urls.sales}/payments`;

export const create = async (options = {}) => {
  return await apiPost(`${base_url}`, { ...options });
};

export const read = async (options = {}) => {
  return await apiGet(base_url, { ...options });
};

export const sendNotice = async (options = {}) => {
  return await apiPost(`${base_url}/notification`, { ...options });
};

export const verify = async (options = {}) => {
  return await apiPost(`${base_url}/rave/verification`, { ...options });
};
